// @flow
export const PRIMARY_BUTTON: string = 'PRIMARY_BUTTON';
export const SECONDARY_BUTTON: string = 'SECONDARY_BUTTON';
export const SECONDARY_LIGHT_BUTTON: string = 'SECONDARY_LIGHT_BUTTON';
export const CTA_BUTTON: string = 'CTA_BUTTON';
